import { render, staticRenderFns } from "./redirection.vue?vue&type=template&id=595a1341"
import script from "./redirection.vue?vue&type=script&lang=js"
export * from "./redirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports